import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Dimmer } from "../../spinner";
import CatalogoTasaImpuesto from "../../../catalogos/catalogoImpuestoLicores";
import { Mensaje } from "../../mensajes2";
import moment from "moment";
import { formatMoneda, validaSoloNumero } from "../../../util/varios";
import axios from "axios";

export const ModalImpuestoTasa = (props) => {
  const op = require("../../../../src/modulos/datos");
  const token = localStorage.getItem("jwtToken");
  const factorCambio = JSON.parse(localStorage.getItem("factorCambio"));
  const [operacion, setOperacion] = useState(0);
  const [mostrarModal, setMostrarModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [body, setBody] = useState({
    codigo: "",
    ordenanza: "",
    descripcion: "",
    fecha: moment(new Date()).format("YYYY-MM-DD"),
    valorUT: "",
    cantidad: 1,
    valor: "",
    total: "",
  });
  const handleAceptaTasaImpuesto = (id, descrip, ordenanza, monto) => {
    try {
      setMostrarModal(false);
      setBody((prev) => ({
        ...prev,
        codigo: id,
        ordenanza: ordenanza,
        descripcion: descrip,
        valorUT: parseFloat(monto),
        valor: parseFloat(monto) * parseFloat(factorCambio?.valor),
        total: parseFloat(monto) * parseFloat(factorCambio?.valor),
      }));
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        text: error,
        icono: "error",
      });
    }
  };
  const handleInputNumChange = (event) => {
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      setBody({ ...body, [event.target.name]: event.target.value });
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };
  const blanquear = () => {
    setOperacion(0);
    setMostrarModal(false);
    setMensaje({
      mostrar: false,
      titulo: "",
      texto: "",
      icono: "",
    });
    setBody({
      codigo: "",
      ordenanza: "",
      descripcion: "",
      fecha: moment(new Date()).format("YYYY-MM-DD"),
      valorUT: "",
      cantidad: 1,
      valor: "",
      total: "",
    });
  };
  const guardarTasa = async () => {
    try {
      if (!body.codigo || !props.idcomercio || (parseFloat(body.cantidad) === 0 || !body.cantidad)) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: "Faltan Datos Obligatorios",
          icono: "error",
        });
        return;
      }
      setLoading(true);
      const endpoint = `${op.conexion}/api/licores/insertartasa/${operacion}`;
      const response = await axios.post(
        endpoint,
        {
          idlico: props.tasas ? props.tasas.idlicores : 0,
          idcome: parseInt(props.idcomercio),
          idtipo: parseInt(body.codigo),
          nmonto: body.valorUT,
          fecins: body.fecha,
          nanio: parseInt(props.annio),
          cantid: parseInt(body.cantidad),
        },
        {
          headers: {
            "x-access-token": `${token}`,
            "Content-Type": "application/json",
          },
        },
      );
      if (response.status === 200 && response.data) {
        const text =
          operacion === 1
            ? "registro creado correctamente "
            : "registro eliminado correctamente";
        setMensaje({
          mostrar: true,
          titulo: "",
          texto: text,
          icono: "exito",
        });
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "error",
        icono: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  const salir = () => {
    props.onHideCancela();
    props.onHIdeRenderizar(props.idcomercio, props.annio);
    props.onHideRenderDeu(props.comercio);
    blanquear();
  };
  useEffect(() => {
    if (!body.valor) return;
    setBody((prev) => ({
      ...prev,
      total: prev.valor * (prev.cantidad || 0),
    }));
  }, [body.cantidad, body.valor, body.valorUT]);
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        if (props.tasas && props.operacion === 3) {
          const { cantidad, monto, idtipotasa } = props.tasas;
          setBody((prev) => ({
            ...prev,
            cantidad: parseInt(cantidad),
            valorUT: monto,
            codigo: idtipotasa,
            ordenanza: idtipotasa,
            valor: parseFloat(monto) * factorCambio?.valor,
          }));
        }
      }}
    >
      <Modal.Header className="azulGradiant px-4 py-2 text-uppercase">
        <h3 className="fs-4 fw-bold text-light m-0">
          {operacion === 1 ? "Incluir Tasa" : "Eliminar Tasa"}{" "}
        </h3>
        <button className="btn btn-sm bg-light" onClick={() => salir()}>
          <i className="fa fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex justify-content-between">
          <div className="col-md-3 row py-2">
            <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
              <span className="input-group-text text-uppercase">Codigo:</span>
              <input
                type="text"
                className="form-control text-uppercase text-right"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
                disabled
                name="codigo"
                value={body.codigo}
              />
              <button
                style={{ textAlign: "center", color: "white" }}
                className="btn btn-sm btn-info"
                onClick={() => setMostrarModal(true)}
              >
                <i className="fas fa-search"></i>
              </button>
            </div>
          </div>
          <div className="col-md-4 row py-2">
            <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
              <span className="input-group-text text-uppercase">
                Codigo Segun Ordenanza:
              </span>
              <input
                type="text"
                disabled
                className="form-control form-control-sm text-right"
                value={body.ordenanza}
              />
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-between">
          <div className="col-md-12 row my-auto py-2 px-0 mx-0">
            <div className="input-group input-group-sm col-md-12 p-0 m-0">
              <span className="input-group-text text-uppercase">
                Descripcion:
              </span>
              <textarea
                disabled
                className="form-control text-uppercase"
                id="inputDireccionContri"
                style={{ height: 60 }}
                value={body.descripcion}
              />
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-between">
          <div className="col-md-4 row py-2">
            <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
              <span className="input-group-text text-uppercase">Fecha</span>
              <input
                type="date"
                disabled
                className="form-control form-control-sm"
                value={body.fecha}
              />
            </div>
          </div>
          <div className="col-md-4 row py-2">
            <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
              <span className="input-group-text text-uppercase">
                Valor U.T.:
              </span>
              <input
                type="text"
                disabled
                className="form-control form-control-sm text-right"
                value={formatMoneda(
                  body.valorUT.toString().replace(".", ","),
                  ",",
                  ".",
                  2,
                )}
              />
            </div>
          </div>
          <div className="col-md-4 row py-2">
            <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
              <span className="input-group-text text-uppercase">Cantidad</span>
              <input
                type="text"
                className="form-control form-control-sm text-right"
                name="cantidad"
                value={body.cantidad}
                disabled={props.operacion === 3}
                onChange={handleInputNumChange}
              />
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-between">
          <div className="col-md-4 row py-2" />
          <div className="col-md-4 row py-2">
            <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
              <span className="input-group-text text-uppercase">Valor</span>
              <input
                type="text"
                disabled
                className="form-control form-control-sm text-right"
                value={formatMoneda(
                  body.valor.toString().replace(".", ","),
                  ",",
                  ".",
                  2,
                )}
              />
            </div>
          </div>
          <div className="col-md-4 row py-2">
            <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
              <span className="input-group-text text-uppercase ">Total</span>
              <input
                type="text"
                disabled
                className="form-control form-control-sm text-right"
                value={formatMoneda(
                  body.total.toString().replace(".", ","),
                  ",",
                  ".",
                  2,
                )}
              />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          onClick={() => guardarTasa()}
          className="btn-sm rounded-pill btn btn-success col-md-2"
        >
          Aceptar <i className="fw-bold far ms-2  fa-check-circle"></i>
        </button>
        <button
          onClick={() => salir()}
          className="btn-sm rounded-pill btn btn-danger col-md-2"
        >
          Salir <i className="fw-bold fas ms-2 fa-window-close"></i>
        </button>
      </Modal.Footer>
      <CatalogoTasaImpuesto
        show={mostrarModal}
        onHideCancela={() => setMostrarModal(false)}
        onHideAceptaTasa={handleAceptaTasaImpuesto}
      />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.icono === "exito"
            ? salir()
            : setMensaje({
                mostrar: false,
                titulo: "",
                texto: "",
                icono: "",
              });
        }}
      />
      <Dimmer active={loading} inverted />
    </Modal>
  );
};
